import React from "react";
import Routes from "./routes";
import { AuthProvider } from "components/ui/navigationGuard";

function App() {
  return (
    <AuthProvider>
      <Routes />
    </AuthProvider>
  );
}

export default App;
